module.exports = __webpack_public_path__ + "static/media/calendar.8a7e0210.jpg";